module.exports = __webpack_public_path__ + "87e30b85528c4373fab7f603f583c242.jpg";